var path = 'directives/sidebarBlockHeader/sidebarBlockHeader.html';
var html = "<div class=left-content-header-container><h1>{{ sidebarBlockHeader.name }}</h1><a href=# class=info-icon ng-mouseover=\"columnsTooltip = true\" ng-mouseleave=\"columnsTooltip = false\"><div class=kff-tooltip ng-show=columnsTooltip><p class=tt-inner><span>{{ sidebarBlockHeader.name }}</span> {{ sidebarBlockHeader.tooltips[sidebarBlockHeader.name][sidebarBlockHeader.view] }}</p></div></a></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./js/directives/sidebarBlockHeader/sidebarBlockHeader.html
// module id = 180
// module chunks = 0